<form clrForm [formGroup]="positionsForm">
  <table *ngIf="editPos < 2" class="table" id="positionsTable">
    <thead>
    <tr>
      <th>Position</th>
      <th></th>
      <th>Teil</th>
      <th>Anzahl</th>
      <th class="left">Zeichnung</th>
      <th class="left">Bezeichnung/Kurzbeschreibung/Spezifikation</th>
      <th class="left">Material</th>
      <th class="left">Kennzeichnung</th>
      <th class="left">Chargen-Nr.</th>
      <th class="left">Kostenstelle</th>
      <th>im Lager</th>
      <th *ngIf="editPos === 1">Aktion</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngIf="posLength === 0; else posTableBlock">
      <td colspan="9">Noch keine Positionen erfasst...</td>
    </tr>
    <ng-template #posTableBlock>
      <ng-container [ngSwitch]="editPos">
        <ng-container *ngSwitchCase="0">
          <ng-container *ngFor="let position of positions; index as i;">
            <tr *ngIf="!position.technology">
              <td (click)="updatePositionMode(i, position.position, position.positions_part ?? 0)"><span *ngIf="(position.positions_part ?? 0) === 0">{{ position.position }}</span></td>
              <td>
                <span *ngIf="position.has_child" (click)="applyPartsList(position.technical_drawing, position.project_number, position.position, position.number_of_pieces ?? 0)">
                  <a [routerLink]="['/project/details', cidPos, pridPos]" role="tooltip" aria-haspopup="true" class="tooltip tooltip-lg tooltip-top-right">
                    <cds-icon *ngIf="(position.positions_part ?? 0) === 0" shape="clone" solid="true"></cds-icon>
                    <span class="tooltip-content">Das ist ein Baugruppe. Durch Klick auf des Symbol können Sie die Teile der Baugruppe zum Projekt hinzufügen.</span>
                  </a>
                </span>
                <span *ngIf="(position.positions_part ?? 0) > 0"><cds-icon shape="child-arrow"></cds-icon></span>
              </td>
              <td><span *ngIf="(position.positions_part ?? 0) > 0;">{{ position.positions_part }}</span></td>
              <td>{{ position.number_of_pieces ?? 0 }}</td>
              <td class="left" [routerLink]="['/component/details', position.technical_drawing]">
                <span *ngIf="position.technology"><cds-icon shape="cog" class="is-solid"></cds-icon></span>
                <span *ngIf="position.standard"><cds-icon shape="node" class="is-solid"></cds-icon></span>
                <span *ngIf="((position.positions_part ?? 0) > 0) && (position.has_child)"><cds-icon shape="bundle" solid="true"></cds-icon></span>
                {{ position.technical_drawing }}
                <span *ngIf="!position.active"><br /><br /><button *ngIf="!position.active" class="btn btn-warning btn-sm">PASSIV! {{ warnPassiv() }}</button></span>
              </td>
              <td class="left">
                <b>{{ position.name }}</b>
                <clr-tooltip *ngIf="position.comment_phm">
                  <cds-icon clrTooltipTrigger role="img" shape="info-circle" size="24" aria-label="PHM comment tooltip"></cds-icon>
                  <clr-tooltip-content clrPosition="bottom-right" clrSize="md" *clrIfOpen>
                    <span>{{ position.comment_phm }}</span>
                  </clr-tooltip-content>
                </clr-tooltip>
                <span *ngIf="position.description"><br />{{ position.description }}</span>
                <span *ngIf="position.taric && position.taric !== '0'"><br />TARIC: {{ position.taric }}</span>
              </td>
              <td class="left">{{ position.material }}</td>
              <td class="left">{{ position.serial_nr }} </td>
              <td class="left">{{ position.heat_nr }} </td>
              <td class="left">{{ position.controlling_nr }} </td>
              <ng-container *ngIf="position.technology else pieces_in_stock">
                <td> - </td>
              </ng-container>

              <ng-template #pieces_in_stock>
                <td>
                  <cds-icon *ngIf="((position.number_of_pieces_in_stock ?? 0) > 0) && ((position.number_of_pieces_in_stock ?? 0) >= (position.number_of_subparts ?? 0))" class="alert-icon tooltip tooltip-lg tooltip-top-left" shape="check-circle" role="tooltip" aria-haspopup="true">
                    <span class="tooltip-content">Es sind derzeit ausreichend Komponenten auf Lager.</span>
                  </cds-icon>
                  {{ position.number_of_pieces_in_stock }}
                </td>
              </ng-template>
            </tr>
            <ng-container *ngIf="position.specification">
              <tr *ngIf="!position.technology">
                <td colspan="5"></td><td colspan="3" class="left"><span class="small">SPEZIFIKATION: {{ position.specification }}</span></td><td colspan="3"></td>
              </tr>
            </ng-container>
          </ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="1">
          <ng-container *ngFor="let position of positions; index as i;">
            <tr *ngIf="!position.technology">
              <td><span *ngIf="(position.positions_part ?? 0) === 0">{{ position.position }}</span></td>
              <td><span *ngIf="(position.positions_part ?? 0) > 0"><cds-icon shape="child-arrow"></cds-icon></span></td>
              <td><span *ngIf="(position.positions_part ?? 0) > 0">{{ position.positions_part }}</span></td>
              <td>{{ position.number_of_pieces ?? 0 }}</td>
              <td class="left" [routerLink]="['/component/details', position.technical_drawing]">
                <span *ngIf="position.technology"><cds-icon shape="cog" class="is-solid"></cds-icon></span>
                <span *ngIf="position.standard"><cds-icon shape="node" class="is-solid"></cds-icon></span>
                <span *ngIf="((position.positions_part ?? 0) > 0) && (position.has_child)"><cds-icon shape="bundle" class="is-solid"></cds-icon></span>
                {{ position.technical_drawing }}
              </td>
              <td class="left">
                <b>{{ position.name }}</b>
                <clr-tooltip *ngIf="position.comment_phm">
                  <cds-icon clrTooltipTrigger role="img" shape="info-circle" size="24" aria-label="PHM comment tooltip"></cds-icon>
                  <clr-tooltip-content clrPosition="bottom-right" clrSize="md" *clrIfOpen>
                    <span>{{ position.comment_phm }}</span>
                  </clr-tooltip-content>
                </clr-tooltip>
                <span *ngIf="position.description"><br />{{ position.description }}</span>
                <span *ngIf="position.taric && position.taric !== '0'"><br />TARIC: {{ position.taric }}</span>
              </td>
              <td class="left">{{ position.material }}</td>
              <td class="left">{{ position.serial_nr }}</td>
              <td class="left">{{ position.heat_nr }}</td>
              <td class="left">{{ position.controlling_nr }} </td>
              <td><span *ngIf="!position.technology"> {{ position.number_of_pieces_in_stock }}</span></td>
              <td class="btn-group btn-primary btn-icon">
                <button *ngIf="!updPos" class="btn btn-sm" (click)="updatePositionMode(i, position.position, (position.positions_part ?? 0))">
                  <cds-icon shape="pencil"></cds-icon>
                  <span class="clr-icon-title">Ändern</span>
                </button>
                <button *ngIf="!updPos" class="btn btn-sm" [routerLink]="['/component/details', position.technical_drawing]">
                  <cds-icon shape="form"></cds-icon>
                  <span class="clr-icon-title">Komponente bearbeiten</span>
                </button>
                <button class="btn btn-danger btn-sm" (click)="deletePosition(position.position, (position.positions_part ?? 0))">
                  <cds-icon shape="trash"></cds-icon>
                  <span class="clr-icon-title">Löschen</span>
                </button>
              </td>
            </tr>
            <ng-container *ngIf="position.specification">
              <tr *ngIf="!position.technology">
                <td colspan="5"></td><td colspan="3" class="left"><span class="small">SPEZIFIKATION: {{ position.specification }}</span></td><td colspan="3"></td>
              </tr>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-template>

    <ng-container *ngIf="(editPos === 1) && (updPos === false) ">
      <tr>
        <td colspan="3" rowspan="2" class="left">Nummern werden automatisch erzeugt...</td>
        <td rowspan="2" class="left"><input type="text" formControlName="number_of_pieces" placeholder="Stückzahl" class="clr-input" required></td>
        <td class="left">
          {{ placeholderI }}
        </td>
        <!--<td class="left" colspan="2"><input type="text" id="editposName" formControlName="name" placeholder="Bezeichnung" class="clr-input" minlength="3" required></td>-->
        <td rowspan="2" class="left" colspan="2"><b>{{ placeholderII }}</b></td>
        <td rowspan="2" class="left"><input type="text" id="editposSerial" formControlName="serial_nr" placeholder="Kennzeichnung" class="clr-input" ></td>
        <td rowspan="2" class="left"><input type="text" id="editposHeat" formControlName="heat_nr" placeholder="Chargen Nr." class="clr-input" ></td>
        <td rowspan="2" class="left"><input type="text" id="editposControlling" formControlName="controlling_nr" placeholder="Kostenstelle" class="clr-input" ></td>
        <td rowspan="2"></td>
        <td rowspan="2" class="btn-group btn-primary btn-icon">
          <button class="btn btn-sm" (click)="addPosition()" [disabled]="positionsForm.invalid">
            <cds-icon shape="floppy"></cds-icon>
            <span class="clr-icon-title">Speichern</span>
          </button>
        </td>
      </tr>
      <tr>
        <td>
          <clr-dropdown [clrCloseMenuOnItemClick]="true">
            <input clrDropdownTrigger class="clr-input"
                   aria-label="Suche Komponenten/Baugruppen..."
                   id="search_input"
                   type="text"
                   placeholder="Suche nach Zeichnungsnummer..."
                   (keyup)="onKeyUp($event)" />
            <cds-icon shape="angle"></cds-icon> (mind. drei Zeichen eingeben)
            <clr-dropdown-menu *clrIfOpen>
              <div *ngFor="let components of foundComponents"
                   clrDropdownItem
                   (click)="preFillRow(components.technical_drawing, components.name)">
                {{ components.technical_drawing }} - {{ components.name }}</div>
            </clr-dropdown-menu>
          </clr-dropdown>
        </td>
      </tr>
    </ng-container>
    </tbody>
  </table>
</form>

<app-edit-position *ngIf="editPos === 2" [projectNumber]="projectNumber" [editPosition]="editPositionNumber"  [editPart]="editPartNumber" (updatedPosition)="updatePosition($event)"></app-edit-position>

<br />
<a *ngIf="editPos === 1" class="btn btn-primary btn-sm" (click)="editPos = 0; updPos = false; updateIndex = 999">Bearbeitung beenden</a>
<a *ngIf="editPos === 0" class="btn btn-primary btn-sm" (click)="editPos = 1">Positionen bearbeiten</a>

<pre *ngIf="devMode" class="datepicker-output">
    {{ positionsForm.value | json }}
</pre>
